import React from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import useFeatureFlags from 'hooks/useFeatureFlags';
import DATE_FORMATS from 'constants/date_format';
import BadgesModal from 'components/Learn/Header/BadgesModal';
import Tooltip from 'components/shared/Tooltip';
import CertificationBadge from 'components/CertificationBadge';
import ViewCertificationModal from 'components/Certificate/ViewCertificationModal';

const BADGE_LIMIT = 3;

export default function CertificationBadgeList({
  certifications,
  toggleCertificateModal,
  totalCertifications,
  toggleModal,
  showModal,
  certificateModalIdToShow,
  closeCertificateModal,
}) {
  const hasUnificationFeatureFlag = useFeatureFlags(
    'readiness-enable-unification',
  );
  return (
    <div
      className={classNames('d-f ai-c mt-8', {
        'mb-16': !hasUnificationFeatureFlag,
      })}
    >
      {certifications.slice(0, BADGE_LIMIT).map(certification => (
        <div
          key={certification.id}
          className={certification.expired ? 'Expired' : undefined}
        >
          <Tooltip
            className="w-220 ws-pr text-wrap"
            position="top"
            align="start"
            text={t('certifications.learn.badge_tooltip', {
              certification_name: certification.path.title,
              date: moment(certification.completedDate).format(
                DATE_FORMATS.SHORT,
              ),
            })}
          >
            <div
              className="d-f mr-12 h-cr-p"
              aria-label={t('certifications.badge_editor.icon')}
              onClick={() =>
                toggleCertificateModal(certification.path.pathProgressId)
              }
              role="button"
              tabIndex="0"
              onKeyDown={e =>
                e.key === 'Enter' &&
                toggleCertificateModal(certification.path.pathProgressId)
              }
            >
              <CertificationBadge
                width={38}
                height={48}
                iconName={certification.badge.iconName}
                foregroundColor={certification.badge.foregroundColor}
                backgroundColor={certification.badge.backgroundColor}
                image={certification.badge.image}
              />
            </div>
          </Tooltip>
        </div>
      ))}
      {totalCertifications > BADGE_LIMIT && (
        <div className="d-f ai-c jc-c">
          <button
            className="u-linkBtn lh-24 fz-18 fw-b c-brand-blue c-transparent-background"
            type="button"
            onClick={toggleModal}
          >
            +{totalCertifications - BADGE_LIMIT}
          </button>
          {showModal && (
            <BadgesModal
              closeModal={toggleModal}
              certifications={certifications}
              showCertificateModal={toggleCertificateModal}
            />
          )}
        </div>
      )}
      {!!certificateModalIdToShow && (
        <ViewCertificationModal
          shown={!!certificateModalIdToShow}
          toggleModal={closeCertificateModal}
          pathProgressId={certificateModalIdToShow}
        />
      )}
    </div>
  );
}

CertificationBadgeList.propTypes = {
  certifications: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      badge: PropTypes.shape({
        iconName: PropTypes.string,
        foregroundColor: PropTypes.string,
        backgroundColor: PropTypes.string,
        image: PropTypes.shape({
          signature: PropTypes.string,
          policy: PropTypes.string,
          handle: PropTypes.string,
        }),
      }),
      path: PropTypes.shape({
        title: PropTypes.string,
        pathProgressId: PropTypes.number,
      }),
      completedDate: PropTypes.string,
    }),
  ),
  toggleCertificateModal: PropTypes.func,
  totalCertifications: PropTypes.number,
  toggleModal: PropTypes.func,
  showModal: PropTypes.bool,
  certificateModalIdToShow: PropTypes.number,
  closeCertificateModal: PropTypes.func,
};
